// Rejects protocol-relative / scheme-confusion paths (`//evil`, `/\evil`) that browsers may normalize off-origin.
export const isSafePath = (path: string | null | undefined): path is string => {
  if (!path || !path.startsWith('/')) return false;
  if (path[1] === '/' || path[1] === '\\') return false;
  return true;
};

export const buildLoginPath = (): string => {
  if (typeof window === 'undefined') return '/login';
  return `/login?postSlug=${encodeURIComponent(window.location.pathname)}`;
};

// Reads `?postSlug=` set by paywall sign-in links; strips `modal` + `postSlug` from preserved params.
export const buildPostAuthRedirectUrl = (): string | undefined => {
  if (typeof document === 'undefined') return;

  const currentSearchParams = new URLSearchParams(document.location.search);
  const postSlug = currentSearchParams.get('postSlug');

  currentSearchParams.delete('modal');
  currentSearchParams.delete('postSlug');

  const path = isSafePath(postSlug) ? postSlug : document.location.pathname;
  const stringifiedParams = currentSearchParams.toString();

  return stringifiedParams
    ? `${document.location.origin}${path}?${stringifiedParams}`
    : `${document.location.origin}${path}`;
};
